module.exports = __webpack_public_path__ + "img/circle-checked-nc.37ceabd8.svg";